// Data store for area-specific unique SEO content to avoid Google duplicate content issues
import { 
  tagamo3ElKhames, tagamo3ElAwal, tagamo3ElTalat,
  nasrCity, katameya, zahraaElMaadi,
  maadi, sakrKorish, heliopolis,
  alsalam, sheraton, elNozha,
  abassia, madinaty, rehab,
  elObour, mokattam, newCapital,
  october, zayed, alex,
  sahel, sokhna, suezRoad
} from './areasContent';

export const areaCustomContent = {
  "التجمع الخامس": tagamo3ElKhames,
  "التجمع الاول": tagamo3ElAwal,
  "التجمع الثالث": tagamo3ElTalat,
  "مدينة نصر": nasrCity,
  "القطامية": katameya,
  "زهراء المعادي": zahraaElMaadi,
  "المعادي": maadi,
  "صقر قريش": sakrKorish,
  "مصر الجديدة": heliopolis,
  "السلام": alsalam,
  "شيراتون": sheraton,
  "النزهة": elNozha,
  "العباسية": abassia,
  "مدينتي": madinaty,
  "الرحاب": rehab,
  "العبور": elObour,
  "المقطم": mokattam,
  "العاصمة الإدارية": newCapital,
  "أكتوبر": october,
  "الشيخ زايد": zayed,
  "اسكندرية": alex,
  "الساحل الشمالي": sahel,
  "طريق السخنة": sokhna,
  "طريق السويس": suezRoad
};
